import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { SHOW_PLAY_QUEUE } from '../actions';
import { PLAY_NEXT, PLAY_PREVIOUS, PLAYBACK_TOGGLE } from '../actions/Playback';
import { DIALOG_TEMPLATE } from '../types/templates/dialog';
import { globals } from '../utils';
const { document, window } = globals;
export default function KeyboardShortcutsListener() {
    var _a, _b, _c;
    const PLAYBACK_SHORTCUTS = {
        SPACE: 'Space',
        LEFT: 'ArrowLeft',
        RIGHT: 'ArrowRight',
        PLAYQUEUE: 'KeyP',
    };
    const dispatch = useDispatch();
    const { mediaId } = useSelector((state) => state.Media);
    const { visualPlayQueue } = useSelector((state) => state.PlaybackStates);
    const { isPlayQueueOpen } = useSelector((state) => state.PlayQueue, shallowEqual);
    const { overlayTemplates } = useSelector((state) => state.TemplateStack);
    const isDialog = ((_a = overlayTemplates[0]) === null || _a === void 0 ? void 0 : _a.interface) === DIALOG_TEMPLATE;
    const isVisualPlayQueueDisabled = (_c = (_b = visualPlayQueue) === null || _b === void 0 ? void 0 : _b.isDisabled, (_c !== null && _c !== void 0 ? _c : true));
    function handleKeyboardShortcuts(e) {
        var _a;
        if (isDialog) {
            return;
        }
        const src = e.srcElement;
        // Don't listen for global shortcuts while the user is typing into an input field
        const inputFields = ['input', 'textarea'];
        if (inputFields.includes((_a = src) === null || _a === void 0 ? void 0 : _a.localName)) {
            return;
        }
        // Prevent Space from scrolling the page.
        // Source: https://stackoverflow.com/questions/22559830/html-prevent-space-bar-from-scrolling-page
        if (e.keyCode === 32 && e.target === document.body) {
            e.preventDefault();
        }
        switch (e.code) {
            case PLAYBACK_SHORTCUTS.PLAYQUEUE:
                if (!isPlayQueueOpen && !isVisualPlayQueueDisabled) {
                    dispatch({ type: SHOW_PLAY_QUEUE });
                }
                break;
            case PLAYBACK_SHORTCUTS.SPACE:
                if (mediaId) {
                    dispatch({ type: PLAYBACK_TOGGLE, payload: { mediaId } });
                }
                break;
            case PLAYBACK_SHORTCUTS.LEFT:
                if (mediaId) {
                    dispatch({ type: PLAY_PREVIOUS, payload: { mediaId } });
                }
                break;
            case PLAYBACK_SHORTCUTS.RIGHT:
                if (mediaId) {
                    dispatch({ type: PLAY_NEXT, payload: { mediaId } });
                }
                break;
        }
    }
    useEffect(() => {
        window.addEventListener('keydown', handleKeyboardShortcuts);
        return () => window.removeEventListener('keydown', handleKeyboardShortcuts);
    }, [isDialog, isVisualPlayQueueDisabled, mediaId]);
    return null;
}
